import { useTranslation } from 'react-i18next';

export const ChargePointsConnectorsHeader = (): React.JSX.Element => {
  const { t } = useTranslation();

  return <>{t('delmonicos-shared-sdk.outputs-charge-point-alt.channels')}</>;
};
